module.exports = __webpack_public_path__ + "static/media/ecola-termite-pest-control.75696050.png";